/**
 * Common - Search molecule
 */

// Imports
import {
  value,
} from '../Utils';

const searchFieldId = 'searchField';
const searchButtonId = 'btnSearch';

/**
 * Reference to the search field element.
 * @type {Object}
 */
let searchField = {};

/**
 * Placeholder for the search field element.
 * @type {Object}
 */
let searchFieldPlaceholder = '';

/**
 * Reference to the search button element.
 * @type {Object}
 */
let searchButton = {};

function getSearchField() {
  return searchField;
}

function getSearchFieldPlaceholder() {
  return searchFieldPlaceholder;
}

function getSearchButton() {
  return searchButton;
}

function saveReferences() {
  // Save reference to the search field element
  searchField = $(`#${searchFieldId}`);

  // Save the placeholder of the earch field element
  searchFieldPlaceholder = value(searchField.attr('placeholder'), '');

  // Save reference to the search button element
  searchButton = $(`#${searchButtonId}`);
}

function goSearchpage(asDefaultValue, c, l) {
  const inputValue = searchField.val();

  if (inputValue.length && inputValue !== asDefaultValue) {
    location.href = `/V2/pages/common/Search.aspx?search=${encodeURIComponent(inputValue)}&c=${c}&l=${l}`;
  }
}

function init() {
  // Save references to DOM elements
  saveReferences();
}

// Named exports - Constants
export {
  searchFieldId,
  searchButtonId,
};

// Named exports - Functions
export {
  init,
  getSearchField,
  getSearchFieldPlaceholder,
  getSearchButton,
  goSearchpage,
};



// WEBPACK FOOTER //
// ./js/common/molecule/search.js